import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Eliminado: import { useLanguage } from '../../contexts/LanguageContext';
import apiInstance from '../../utils/axios';
import ProductCard from '../../components/ProductCard';

const CuratedProductsShowcase = () => {
  // Eliminado: const { t } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFeatured, setIsFeatured] = useState(false);

  useEffect(() => {
    const fetchCuratedProducts = async () => {
      try {
        // Use direct endpoints in production
        const offersResp = await apiInstance.get('offers-carousel/');
        let products = Array.isArray(offersResp.data) ? offersResp.data : (offersResp.data.results || []);
        if (!products.length) {
          const fallback = await apiInstance.get('products/');
          products = Array.isArray(fallback.data) ? fallback.data : (fallback.data.results || []);
        }
        
        setProducts(products);
      } catch (error) {
        console.error('Error fetching curated products:', error);
        // Final fallback to regular products
        try {
          const fallbackResponse = await apiInstance.get('products/');
          const fallbackData = Array.isArray(fallbackResponse.data) ? fallbackResponse.data : (fallbackResponse.data.results || []);
          setProducts(fallbackData.slice(0, 8));
          setIsFeatured(false);
        } catch (fallbackError) {
          console.error('Error fetching fallback products:', fallbackError);
          setProducts([]);
          setIsFeatured(false);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCuratedProducts();
  }, []);

  const containerStyle = {
    maxWidth: '1200px',
    margin: '80px auto',
    padding: '32px',
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    border: '1px solid #f0f0f0',
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '40px',
  };

  const titleStyle = {
    fontSize: '28px',
    fontWeight: '500',
    color: '#333',
    margin: '0 0 8px 0',
  };

  const subtitleStyle = {
    fontSize: '16px',
    color: '#666',
    margin: 0,
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 200px))',
    gap: '16px',
    justifyContent: 'center',
    padding: '0 8px',
  };

  const skeletonStyle = {
    backgroundColor: '#f3f4f6',
    borderRadius: '12px',
    height: '340px',
    animation: 'pulse 2s infinite'
  };

  if (loading) {
    return (
      <div style={containerStyle}>
        <div style={headerStyle}>
          <div>
            <h2 style={titleStyle}>Productos destacados</h2>
            <p style={subtitleStyle}>Una selección especial para vos</p>
          </div>
        </div>
        <div className="curated-products-grid" style={gridStyle}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={skeletonStyle} />
          ))}
        </div>
      </div>
    );
  }

  if (products.length === 0) {
    return null; // Don't render if no products
  }

  const containerHoverStyle = {
    ...containerStyle,
    overflow: 'hidden',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  };

  const linkStyle = {
    color: '#333',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '500',
    padding: '8px 0',
    borderBottom: '2px solid #333',
    transition: 'all 0.3s ease',
  };

  const ctaStyle = {
    textAlign: 'center',
    paddingTop: '20px',
    borderTop: '1px solid #f0f0f0',
  };

  const ctaButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#00a650',
    color: 'white',
    textDecoration: 'none',
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 8px rgba(0, 166, 80, 0.2)',
  };

  const handleContainerMouseEnter = (e) => {
    e.currentTarget.style.boxShadow = '0 8px 40px rgba(0,0,0,0.12)';
    e.currentTarget.style.borderColor = '#e0e7ff';
  };

  const handleContainerMouseLeave = (e) => {
    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
    e.currentTarget.style.borderColor = '#f0f0f0';
  };

  const handleLinkMouseEnter = (e) => {
    e.target.style.borderBottomColor = '#00a650';
    e.target.style.color = '#00a650';
  };

  const handleLinkMouseLeave = (e) => {
    e.target.style.borderBottomColor = '#333';
    e.target.style.color = '#333';
  };

  const handleCtaMouseEnter = (e) => {
    e.target.style.backgroundColor = '#008f47';
    e.target.style.transform = 'translateY(-1px)';
    e.target.style.boxShadow = '0 4px 12px rgba(0, 166, 80, 0.3)';
  };

  const handleCtaMouseLeave = (e) => {
    e.target.style.backgroundColor = '#00a650';
    e.target.style.transform = 'translateY(0)';
    e.target.style.boxShadow = '0 2px 8px rgba(0, 166, 80, 0.2)';
  };

  return (
    <div 
      className="curated-products-container"
      style={containerHoverStyle}
      onMouseEnter={handleContainerMouseEnter}
      onMouseLeave={handleContainerMouseLeave}
    >
      <div style={headerStyle}>
        <div>
          <h2 style={titleStyle}>
            {isFeatured ? 'Productos destacados' : 'Productos populares'}
          </h2>
          <p style={subtitleStyle}>
            {isFeatured ? 'Una selección especial para vos' : 'Descubrí nuestros productos más elegidos'}
          </p>
        </div>
        <Link 
          to="/products" 
          style={linkStyle}
          onMouseEnter={handleLinkMouseEnter}
          onMouseLeave={handleLinkMouseLeave}
        >
          Ver todos
        </Link>
      </div>

      <div className="curated-products-grid" style={gridStyle}>
        {products && products.map((product) => (
          <ProductCard key={product.id} product={product} variant="compact" />
        ))}
      </div>

      <div className="curated-products-cta" style={ctaStyle}>
        <Link 
          to="/products" 
          style={ctaButtonStyle}
          onMouseEnter={handleCtaMouseEnter}
          onMouseLeave={handleCtaMouseLeave}
        >
          Ver todos los productos <span style={{ fontSize: '16px' }}>→</span>
        </Link>
      </div>
      
      <style>
        {`
          /* Mobile Responsiveness for Popular Products */
          @media (max-width: 768px) {
            .curated-products-container {
              margin: 40px auto !important;
              padding: 20px !important;
              border-radius: 12px !important;
            }
            
            .curated-products-container h2 {
              font-size: 22px !important;
              margin-bottom: 4px !important;
            }
            
            .curated-products-container p {
              font-size: 14px !important;
            }
            
            .curated-products-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 12px !important;
              padding: 0 !important;
            }
            

            
            .curated-products-cta {
              padding-top: 16px !important;
            }
            
            .curated-products-cta a {
              padding: 10px 20px !important;
              font-size: 13px !important;
            }
          }
          
          @media (max-width: 480px) {
            .curated-products-container {
              margin: 20px auto !important;
              padding: 16px !important;
              border-radius: 8px !important;
            }
            
            .curated-products-container h2 {
              font-size: 20px !important;
            }
            
            .curated-products-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 10px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CuratedProductsShowcase;
